import React, { FC } from 'react';
import { GeneralOverviewPageRenderedComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import GlobalExposureTable from './GlobalExposureTable';
import GridItem from '../../../layout/GridComponents/GridItem';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import { useGlobalExposurePageQuery } from '../../../../api/rs-hg/risk/hooks/queries';
import type { GlobalExposurePayload } from '../../../../api/rs-hg/risk/globalExposure.types';

const GlobalExposure: FC<GeneralOverviewPageRenderedComponentProps> = ({
  positionDate,
  section,
  pageId,
}) => {
  const globalExposureQuery = useGlobalExposurePageQuery(positionDate);

  return (
    <QueryBoundary<GlobalExposurePayload>
      isLoading={globalExposureQuery.isLoading}
      isFetching={globalExposureQuery.isFetching}
      isError={globalExposureQuery.isError}
      error={globalExposureQuery.error}
      data={globalExposureQuery.data?.data}
      loadingMessages={['Loading Global Exposure...']}
      errorMessage="Unable to load Global Exposure data."
      noDataMessage="No Global Exposure data available."
    >
      {(data) => (
        <GridItem xs={12} card>
          <GlobalExposureTable
            rows={data}
            section={section}
            pageId={pageId}
          />
        </GridItem>
      )}
    </QueryBoundary>
  );
};

export default GlobalExposure;
